const firebaseConfig = {
    apiKey: "AIzaSyB1wG3ZftWFyarumQV0xxIUcPsZRiZWF3s",
    authDomain: "creative-agency-f.firebaseapp.com",
    databaseURL: "https://creative-agency-f.firebaseio.com",
    projectId: "creative-agency-f",
    storageBucket: "creative-agency-f.appspot.com",
    messagingSenderId: "506360390824",
    appId: "1:506360390824:web:4f77f5d76fb57d75518e9d"
  };

  export default firebaseConfig;